import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { UploadCloud } from "lucide-react";
import { useProfile } from "@/context/ProfileContext";
import { ManageTracks } from "@/components/music/ManageTracks";

export const MyTracks = () => {
  const { profile, request } = useProfile();
  const [tracks, setTracks] = useState(null);
  useEffect(() => { request("get", `/profiles/${profile.username}/tracks`).then(setTracks).catch(() => setTracks([])); }, [profile.username, request]);

  return (
    <section data-testid="my-tracks-section" className="space-y-3">
      <div className="flex items-center justify-between">
        <h2 className="font-display text-xl font-bold text-white">My tracks</h2>
        <Link to="/upload" data-testid="my-tracks-upload-link" className="inline-flex items-center gap-1.5 text-sm font-semibold text-nw-red hover:underline"><UploadCloud className="h-4 w-4" /> Upload</Link>
      </div>
      {tracks && <ManageTracks tracks={tracks} setTracks={setTracks} />}
    </section>
  );
};
